/* Global: Table info
 ========================================================================== */

template.table_info = function() {
  var tableContainer = $('.table-outer-container');

  $(tableContainer).each(function () {
    if($(this).find('> .table-container > table').width() > $(this).width()) {
      $(this).find('.table-info').addClass('active');
    }
  });
};
